let Names = [
    'UserSettings',
    'Logout',
    'Home',

    'FileUpload',
    'BatchOverview',
    'ICCT',
    'MetaAnalysis',
    'Monitor',
    'Manual-Manipulation',

    'Impress',
    'Privacy',


    'AdminArea',
    'Help',
    'Login',
    //'Register',
];

let Components = Names.map(e => Promise.all([e, import( './' + e )]));

export {Names as default, Components};